import { getCurrentUserId } from 'auth/userIdentity';
import type { AccessDatabaseUser } from 'store/storageunits/types';

export const isShared = (access?: AccessDatabaseUser) => {
  if (access) {
    const { direct, indirect } = access;
    const accessArray = direct.concat(indirect);
    if (accessArray.length === 0) {
      return false;
    }

    // If a user has access to a descending file or folder but not directly to the current folder, the icon should be a shared folder icon
    const currentUserId = getCurrentUserId();
    const hasAccess = accessArray.some((u) => u === currentUserId);
    return accessArray.length > 1 || !hasAccess;
  }
  return false;
};

export const hasInheritAccess = (access?: AccessDatabaseUser) => {
  if (access) {
    const { direct, indirect } = access;
    const accessArray = direct.concat(indirect);
    const currentUserId = getCurrentUserId();
    return accessArray.some((user) => user === currentUserId);
  } else {
    return false;
  }
};
